// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "toastNotification" + ".twh." + "6bd872ee" + ".css";
};